import EmailSkill from './EmailSkill';
import SmsSkill from './SmsSkill';
import TextSkill from './TextSkill';

export default {
  'EMAIL': EmailSkill,
  'SMS': SmsSkill,
  'TEXT': TextSkill,
};

